import React from 'react';
import GeoBrandLogo from '../features/geo/components/GeoBrandLogo';
import { resolveCompanyBrand } from '../utils/companyBrandLogos';

export default function CompanyBrandCell({
  companyName,
  subjectCompany = '',
  className = '',
  labelClassName = '',
  emptyLabel = '—',
}) {
  const raw = String(companyName || '').trim();
  if (!raw) return emptyLabel;

  const brand = resolveCompanyBrand(raw, { subjectCompany });

  return (
    <span className={`geo-brand-name-cell ${className}`.trim()}>
      <GeoBrandLogo
        name={brand.displayName}
        color={brand.color}
        logoUrl={brand.logoUrl}
        isClient={brand.isClient}
      />
      <span
        className={`geo-brand-name-cell__label ${labelClassName}`.trim()}
        title={raw}
      >
        {brand.displayName}
      </span>
    </span>
  );
}
